import { filterPage } from "components/common/Filters/FiltersHelper";
import ActionPlans from "./actionPlans";
import IndividualAction from "./individualAction";

export const tabDetails = [
  {
    label: "Action Plans",
    content: ActionPlans,
    filtersToClear: [filterPage.libraryFunctionalAreasDisplay, filterPage.libraryAllPlansSearchDisplay]
  },
  {
    label: "Individual Actions",
    content: IndividualAction,
    filtersToClear: [
      filterPage.libraryFunctionalAreasIndividualActionsDisplay,
      filterPage.libraryAllPlansSearchIndividualActionsDisplay
    ]
  }
];
